import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { EcoTradePagina } from '../pages/EcoTrade';

const Router = () => {

    return (
        <BrowserRouter>
            <Routes>
                <Route path='/' element={<EcoTradePagina/>}/>
                <Route path='*' element={<EcoTradePagina/>}/>
            </Routes>
        </BrowserRouter>
    )
}

export default Router;